/**
 * 画像を読み込むときの URL を作る。
 *
 * API が返す画像の URL は S3 の署名付き URL（`X-Amz-Signature` などのクエリ付き）になる。
 * 署名付き URL は末尾にクエリを足すと署名が合わず 403 になる（`?t=` でも `&t=` でも同じ）。
 * 署名付き URL は API を呼ぶたびに署名の中身（X-Amz-Date など）が変わるので、
 * キャッシュ回避のために何かを足す必要もない。
 */

/** S3 の署名付き URL か（SigV4 の X-Amz-Signature / SigV2 の Signature） */
export function isPresignedUrl(url: string): boolean {
  return /[?&](?:X-Amz-Signature|Signature)=/i.test(url);
}

/**
 * 画像の読み込み用 URL を返す。
 * - 署名付き URL: そのまま返す（足すと 403 になる）
 * - 署名の無い URL（旧形式の公開 URL）: 従来どおりキャッシュ回避の `t=<時刻>` を足す
 */
export function imageSrcForLoad(url: string, now: number = Date.now()): string {
  if (isPresignedUrl(url)) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}t=${now}`;
}
